<template>
  <b-card class="mb-3 shadow">
    <h3 slot="header" class="h6 m-0 text-muted">
      {{ $t("documents-my-contract") }}
    </h3>
    <div v-for="(contrat, i) in contrats" :key="i">
      <b-media>
        <svgicon
          slot="aside"
          icon="invoice"
          width="48"
          height="48"
          color="#ddd"
        ></svgicon>
        <div class="row">
          <div class="col-sm-6 col-lg-7">
            <p class="h5 mb-1">
              <span class="text-muted">{{ $t("documents-contract") }}</span>
              {{ contrat.pk }}
            </p>
            <p class="small mb-1" v-if="contrat.validiteStart">
              {{ $t("documents-receipt-signed-on") }}
              {{ contrat.validiteStart }}
            </p>
          </div>
          <div class="col-sm-6 col-lg-5">
            <b-btn
              target="_blank"
              variant="primary"
              size="sm"
              block
              @click="
                checkFileExistanceAndDownload(
                  contrat.fileAccessPath + contrat.fileName.trim(),
                  contrat.fileName
                )
              "
            >
              <svgicon icon="download" class="mr-1"></svgicon>
              {{ $t("documents-download-btn") }}
            </b-btn>
          </div>
        </div>
      </b-media>
      <hr v-if="i != contrats.length - 1" />
    </div>
    <b-media v-if="isLoading && !contrats.length" class="mb-3 text-center">
      <spinner height="128" width="128"></spinner>
    </b-media>
    <b-media v-if="!isLoading && !contrats.length && !error" class="mb-3">
      {{ $t("documents-no-data") }}
    </b-media>
    <b-media v-if="error" class="mb-3" v-html="$t('documents-data-error')">
    </b-media>
  </b-card>
</template>

<script>
import Spinner from "../../Helpers/Spinner/Spinner.vue";
import DownloadPdf from "../../Mixins/downloadPdf.js";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Spinner
  },
  mixins: [DownloadPdf],
  data() {
    return {
      contrats: [],
      error: false
    };
  },
  created() {
    if (!this.contractData) {
      this.loadContracts();
    } else {
      this.loading = false;
      this.contrats = this.contractData;
    }
  },
  computed: {
    ...mapGetters("document", ["contractData", "contractError"]),
    ...mapGetters(["isLoading"])
  },
  watch: {
    contractData(newData) {
      this.contrats = newData;
    },
    contractError(newError) {
      if (newError) {
        this.error = true;
      }
    }
  },
  methods: {
    ...mapActions("document", ["loadContracts"])
  }
};
</script>
